module.exports = __webpack_public_path__ + "img/toco.c146575b.svg";